<template>
    <div>
        <div class="common_btnBar">
            <el-button type="primary" @click="addData">{{ $t('btn.Add') }}</el-button>
        </div>
        <div v-for="item, index in configList" class="config_row">
            <div class="remove_btn" @click="removeData(index)" v-if="index > 0 || configList.length > 1">
                <i class="el-icon-close"></i>
            </div>
            <configPiece :form-data="item" :key="index" :lineAnd="configList.length > 1" :lineContent="index > 0"
                :fieldList="fieldList" :getDataList="getDataList()" :refs="'configPiece_' + index" v-if="dis" />
        </div>
    </div>
</template>

<script>
import configPiece from './configPiece.vue';
import { activityRuleApi } from '@/views/newApplicationForm/service/index.js';
export default {
    name: 'configRule',
    components: {
        configPiece
    },
    props: {
        configList: {
            type: Array,
            default: () => [{}]
        },
        fieldList: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data() {
        return {
            // configList: [{}],
            dis: true
        }
    },
    methods: {
        addData() {
            this.configList.push({});
        },
        removeData(index) {
            this.dis = false
            this.$nextTick(() => {
                this.configList.splice(index, 1);
                this.dis = true
            })
        },
        /**
         * 这个函数传递了三层，传到最内层的config配置，整个配置项每条配置只能配置一次，没两条之间不能重复
         */
        getDataList() {
            let ret = []
            for (let i of this.fieldList) {
                // 获取configList中是否包含i.prop的key如果包含则不添加
                let isExist = false
                for (let arr of this.configList) {
                    if (arr[i.prop]) {
                        isExist = true
                        break
                    }
                }
                if (!isExist) {
                    ret.push(i)
                }
            }
            return ret
        }
    }
}
</script>

<style lang="scss" scoped>
.config_row {
    position: relative;
}

.remove_btn {
    position: absolute;
    right: 10px;
    top: 16px;
    cursor: pointer;
    z-index: 10;

    .el-icon-close {
        font-size: 16px;
    }
}
</style>